
<b-modal
  id="addComatFlightModal"
  ref="addComatFlightModal"
  hide-footer
  hide-header
  size="xl"
  title="erere"
  body-class="modal-body-wo"
  @hide="modalHiding"
>
  <modal-window :mainWidth="12">
    <div>
      <div class="label">Possible Routings</div>
      <div class="d-flex justify-content-between text-center filter-menu mb-4">
        <div class="first-filter">
          <div class="label">Date</div>
          <board-item-date-picker v-model="filters.date" mode="date"></board-item-date-picker>
        </div>
        <div>
          <div class="label">Flight</div>
          <input type="text" class="form-control" v-model="filters.flightNo" />
        </div>
        <div>
          <div class="label">Operator</div>
          <input type="text" class="form-control" v-model="filters.operator" />
        </div>
        <div>
          <div class="label">Type</div>
          <input type="text" class="form-control" v-model="filters.aircraftType" />
        </div>
        <div>
          <div class="label">Registration</div>
          <input type="text" class="form-control" v-model="filters.aircraftRegistration" />
        </div>
        <div>
          <div class="label">Departure</div>
          <input type="text" class="form-control" v-model="filters.departureAirport" />
        </div>
        <div>
          <div class="label">Arrival</div>
          <input type="text" class="form-control" v-model="filters.arrivalAirport" />
        </div>
        <div class="">
          <div class="label">State</div>
          <input type="text" class="form-control" v-model="filters.flightState" />
        </div>
      </div>

      <div class="mt-2 mb-3" v-for="(route, index) in filteredcomatRouting" :key="index">
        <div class="d-flex justify-content-between">
          <div class="label">Route {{ index + 1 }} - {{route.numberOfFlights}} Flights</div>
          <div style="min-width: 65px;">
            <button class="btn btn-block btn-sm btn-success mb-1" @click="saveComatRoute(route)">
              Select
            </button>
          </div>
        </div>

        <div v-for="flight in route.flights" :key="flight.id">
          <FlightInfo :flight="flight"></FlightInfo>
        </div>
      </div>
    </div>
  </modal-window>
</b-modal>
